import Api from '@/shared/services/Api'


export default 
{

	sendMessage(data) {
		return Api().post('contact-send-message', data)
	}

}